import type { BodyRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ReportPostBody = {
  abuse_report: {
    content_object_id: string;
  };
};

export const reportContentObject = async ({ body }: BodyRequest<ReportPostBody>) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.contentObjects.report, body);
